import { useSearchParams } from "react-router-dom";
import { CustomizedCalendar } from "./_components/customized-calendar";

const EmployeeAttendanceForAdmin = () => {
  const [searchParams] = useSearchParams();
  const name = searchParams.get("n");

  return (
    <div className="p-2 h-screen">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">
          {name ? `${name}'s Attendance` : `Employee's Attendance`}
        </h3>
      </div>

      <CustomizedCalendar />
    </div>
  );
};

export default EmployeeAttendanceForAdmin;
